<template>
  <div class="resource-detail">

    <!-- 顶部 -->
    <div class="top-message">
      <ResourceTopMsg :resourceData='resourceData' :fileIdList='fileIdList' />
    </div>

    <!-- 展示内容 -->
    <div class="bottom-content">
      <div ref="contentView" class="content-view">
        <div class="content-view-title">
          预览
          <span>(当资源出现错误或无法预览时，请您下载观看，感谢您的理解！！)  </span>
        </div>
        <div v-if="!this.$route.query.type" class="iframe-box">
          <iframe v-if="loadFlag" allowfullscreen='true' name="myiframe" id="myiframe" ref="iframe" :src="url" frameborder="0"
            width="100%" height="100%" scrolling="no">
          </iframe>
          <div class="preLoad-cont" v-else>
            <div class="preLoad-center">
               <div><img src="../../assets/img/resourceCenter/playIcon.png" alt=""></div>
               <div class="preloda-text">视频转码中，请稍等...</div>
            </div>
          </div>
        </div>

        <div v-if="this.$route.query.type=='ebook'" class="iframe-box ebook">
          <img v-if="resourceData.coverPath" width="100%" height="100%" :src="resourceData.coverPath" alt="">
          <div @click="readBtn" class="read">
            <i class="el-icon-notebook-2"></i>
            <span>阅读</span>
          </div>
        </div>
      </div>

      <!-- 推荐 -->
      <div class="recommend">

        <div v-if="!this.$route.query.type" class="file-box">
          <div class='file-title'>文件</div>
          <ul class="file-list">
            <li class="file-item" @click="_selectFile(item)" :class="{'file-item-active':(item==currentFileId)}"
              v-for="(item,index) of fileIdList" :key="item">P{{index}}-{{resourceData.name}}</li>
          </ul>
        </div>

        <div class="recommend-box">
          <div class="recommend-title">相关推荐</div>
          <div v-if="resourceData.sibling&&resourceData.sibling.length!=0" class="recommend-list">
            <div class="recommend-item" @click="_goRecommend(item)" v-for="(item,index) of resourceData.sibling"
              :key="item.id+index">
              <img class="recommend-item-img" :src="imgUrl(item.fileType)" alt="">
              <span class="recommend-item-content">{{item.name}}</span>
            </div>
          </div>

          <div class="recommend-list" v-else>
            <span>暂无推荐</span>
          </div>
        </div>

      </div>
    </div>

    <!-- 评论 -->
    <div class="resource-detail-comment">
      <ResourceComment :currentFileId='currentFileId' />
    </div>

  </div>
</template>

<script>
import $ from "jquery";
import { PREVIEW_URL } from "@/network/IPconfig";

import { getIdResource,getAddressOssId,getPath,getPathData} from "@/network/resourceRequest/api";
//资源顶部信息--------------------------------------------
import ResourceTopMsg from "./components/ResourceTopMsg";
//评论--------------------------------------------
import ResourceComment from "./components/ResourceComment";

export default {
  name: "ResourceDetail",
  components: {
    ResourceTopMsg,
    ResourceComment,
  },
  data() {
    return {
      //iframe地址
      url: "",
      //iframe高度--------------------------------------------
      mediaHeight: "",
      //资源数据
      resourceData: {},
      //文件id列表--------------------------------------------
      fileIdList: {},
      //当前文件ID--------------------------------------------
      currentFileId: "",
      loadFlag:true
      
    };
  },

  created() {
    console.log(this.$route.query)
    this._initResource();
  },

  mounted() {
    //挂载之后动态获取iframe里面内容的高度  非图书时调用
    if (!this.$route.query.type) {
      this._getHeight();
    }
  },

  watch: {
    mediaHeight(newVal) {
      if (newVal) {
        $(".iframe-box").css("height", newVal);
      }
    },
    $route(newVal) {
      this.$router.go(0);
    },
  },

  methods: {
    //初始化资源
    _initResource() {
      //获取资源数据
      getIdResource(this.$route.query.id).then((res) => {
        console.log('---------------ling',res)
        if (res.data.success) {
          this.resourceData = res.data.data;
          this.fileIdList = res.data.data.fileIdList;
          this.currentFileId = res.data.data.fileIdList[0];
          //非图书时调用--------------------------------------------
          if (!this.$route.query.type) {
            this._setUrl();
          }
        }
      });
    },
  
    //获取盒子高度
    _getHeight() {
      let that = this;
      let a = setInterval(() => {
        var ifr = document.querySelector("#myiframe");
        if (ifr) {
          ifr.contentWindow.postMessage({ a: 1 }, "*");
        }
      }, 100);

      window.addEventListener(
        "message",
        function (e) {
          if (e.data) {
            if (e.data.clientHeight) {
              if (that.resourceData.type == "动画") {
                that.mediaHeight = 600;
              } else {
                that.mediaHeight = e.data.clientHeight;
              }
              //有高度  过两秒后再清除  防止高度不是最终高度
              setTimeout(() => {
                clearInterval(a);
              }, 5000);
            }
          }
        },
        false
      );
    },

    //当前选择的文件--------------------------------------------
    _selectFile(id) {
      this.currentFileId = id;
      this._setUrl();
    },

    //更新预览地址
    async _setUrl(resourceId) {
      let origin = location.origin;
      let newVal = `${PREVIEW_URL}/yulan?id=${this.currentFileId}&resourceId=${this.resourceData.id}&officePreviewType=pdf`;
      if (this.url != newVal) {    
        if(this.$route.query.typeState =='视频课程'|| this.$route.query.typeState =='视频' ||this.$route.query.typeState =='电教-视频'){
          let result = await getAddressOssId(this.currentFileId);
          if(result.data.success){
            let data = {
              path:result.data.data,
              resourceId:this.currentFileId,
              resourceType:2
            }
            let resPath = await getPath(data);
            console.log('resPath',resPath)
            if(resPath.data.data.transcodingStatus == 0){
              let param = {
                resourceId:this.currentFileId,
                resourceType:2,
                tableNameType:0,
                callbackAddress:'https://test-resource.amdox.com.cn/resource-center/'
              }
              let resPathData = await getPathData(param);
              if(resPathData.data.success){
                this.loadFlag = false;
              }
              console.log('resPathData---------',resPathData)
            }else{
              this.loadFlag = true;
              this.url = newVal;
            }
          }
        }else{
            this.loadFlag = true;
            this.url = newVal;
        }
      }
    },

    //前往阅读页面--------------------------------------------
    readBtn() {
      let url = `${PREVIEW_URL}/yulan?id=${this.currentFileId}&resourceId=${this.resourceData.id}&officePreviewType=image`;
      window.open(url);
    },

    //前往推荐--------------------------------------------
    _goRecommend(item) {
      let id = item.id;
      let type = this.$route.query.type;
      if (type) {
        this.$router.push({
          path: "/resource-detail",
          query: { id, type },
        });
      } else {
        this.$router.push({
          path: "/resource-detail",
          query: { id },
        });
      }
    },
  },

  computed: {
    //获取图片封面--------------------------------------------
    imgUrl() {
      return function (type) {
        switch (type) {
          case "pdf":
            return require("@/assets/img/resourceCenter/pdf.png");
            break;
          case "ppt":
          case "pptx":
            return require("@/assets/img/resourceCenter/ppt.png");
            break;
          case "word":
            return require("@/assets/img/resourceCenter/word.png");
            break;
          case "excel":
            return require("@/assets/img/resourceCenter/excel.png");
            break;
          //视频--------------------------------------------
          case "mp4":
            return require("@/assets/img/resourceCenter/shipin.png");
            break;
          //音频--------------------------------------------
          case "mp3":
            return require("@/assets/img/resourceCenter/yinpin.png");
            break;
          //图片--------------------------------------------
          case "jpg":
          case "jpeg":
          case "png":
          case "gif":
          case "bmp":
            return require("@/assets/img/resourceCenter/tupian.png");
            break;
          default:
            return require("@/assets/img/resourceCenter/weizhi.png");
            break;
        }
      };
    },
  },
};
</script>

<style lang='less' scoped>
.preLoad-cont {
  background: #000;
  width:100%;
  height:100%;
  .preLoad-center{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    font-size: 16px;
    color: #888;
    .preloda-text {
      margin-top: 10px;
    }
  }
}
.bottom-content {
  display: flex;

  margin: 20px auto 0;
  width: 1200px;

  justify-content: space-between;

  .content-view {
    border-radius: 2px;
    width: 960px;

    background-color: #fff;

    .content-view-title {
      position: relative;

      margin: 20px 0;
      padding-left: 24px;

      font-size: 16px;
      font-weight: bold;

      color: #333;

      &::before {
        display: inline-block;

        position: absolute;
        top: 50%;
        left: 0;

        border-radius: 5px;
        width: 4px;
        height: 40px;

        background-color: #24ba58;

        transform: translateY(-20px);

        content: "";
      }
    }

    .iframe-box {
      margin: 20px 40px 40px;
      border: 6px solid #ecf0f2;
      height: 700px;
    }

    .ebook {
      position: relative;

      margin: 20px 40px 80px;
      border: 6px solid #ecf0f2;
      height: 500px;

      .read {
        position: absolute;
        bottom: -70px;
        left: -5px;

        border-radius: 5px;
        width: 140px;
        height: 50px;

        font-size: 16px;
        line-height: 50px;
        text-align: center;

        color: #fff;
        background-color: #24ba58;

        cursor: pointer;
        user-select: none;

        &:hover {
          box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);

          transform: translateY(-1px);
        }
        i {
          margin-right: 2px;
        }
      }
    }

    // 图片时样式
    .iframe-img {
      border: 6px solid #ecf0f2;
    }
  }

  .recommend {
    width: 220px;
    min-height: 500px;

    .file-box {
      margin-bottom: 20px;
      padding-bottom: 20px;

      background-color: #fff;

      .file-title {
        border-radius: 2px 2px 0 0;
        padding-left: 20px;
        height: 60px;

        line-height: 60px;

        box-shadow: 0 1px 0 0 rgba(229, 229, 229, 1);
      }

      .file-list {
        overflow: auto;

        margin-top: 20px;
        max-height: 300px;

        .file-item {
          overflow: hidden;

          padding: 10px 10px 10px 20px;
          width: 100%;

          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .file-item:hover {
          color: #fff;
          background-color: #24ba58;

          cursor: pointer;
        }

        .file-item-active {
          color: #fff;
          background-color: #24ba58;
        }
      }
    }

    .recommend-box {
      background-color: #fff;
      .recommend-title {
        border-radius: 2px 2px 0 0;
        padding-left: 20px;
        height: 60px;

        line-height: 60px;

        box-shadow: 0 1px 0 0 rgba(229, 229, 229, 1);
      }

      .recommend-list {
        padding: 20px;

        .recommend-item {
          display: flex;

          margin-bottom: 10px;
          padding: 10px;

          transition: all 0.3s;

          cursor: pointer;

          align-items: center;

          .recommend-item-img {
            margin-right: 10px;
            width: 20px;
            height: 20px;
          }

          .recommend-item-content {
            overflow: hidden;

            white-space: nowrap;
            text-overflow: ellipsis;

            flex: 1;
          }
        }
        .recommend-item:hover {
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);

          transform: translateY(-2px);
        }
      }
    }
  }
}

.resource-detail-comment {
  margin: 20px auto;
  width: 1200px;
  min-height: 356px;
}
</style>